import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Grow from '@material-ui/core/Grow';

// STORE
import { PartnerActions } from '@/store/actions';

// HOOKS
import useActions from '@/hooks/useActions';

// COMPONENTS
import InternetOption from '@/components/Cards/InternetOption';

function PartnerInternetOffer({ partnerBundleSlugs }) {
  const {
    isIframe,
    isAuth,
    unique_id,
    internetOffers,
    internetOffersLoading,
    partner,
    partnerSettings,
    partnerInternetOffer,
    partnerInternetOfferLoading,
    claimPartnerInternetOfferLoading,
  } = useSelector(({ app, auth, user, partner: partnerStore }) => ({
    isIframe: app.isIframe,
    isAuth: auth.isAuth,
    unique_id: auth.unique_id,
    internetOffers: user.internetOffers,
    internetOffersLoading: user.loadings.internetOffers,
    partner: partnerStore.data,
    partnerSettings: partnerStore.data?.settings || {},
    partnerInternetOffer: partnerStore.internetOffer,
    partnerInternetOfferLoading: partnerStore.loadings.internetOffer,
    claimPartnerInternetOfferLoading: partnerStore.loadings.claimInternetOffer,
  }));

  const [getPartnerInternetOffer, claimPartnerInternetOffer] = useActions([
    partner_id => PartnerActions.getPartnerInternetOffer.action({ partner_id }),
    offer_id => PartnerActions.claimPartnerInternetOffer.action({ offer_id }),
  ]);

  const partnerId = partner?.id;
  const partnerSlug = partner?.partner_slug;
  const hasPartner = Boolean(partnerSlug);
  const needLoadInternetOffer = hasPartner && isAuth && partnerBundleSlugs.includes(partnerSlug);
  const internetOffer = internetOffers.length && internetOffers[0];

  useEffect(() => {
    if (needLoadInternetOffer) {
      getPartnerInternetOffer(partnerId);
    }
  }, [needLoadInternetOffer, partnerId]);

  if (
    !hasPartner ||
    (needLoadInternetOffer && !partnerInternetOffer) ||
    partnerInternetOfferLoading ||
    internetOffersLoading
  ) {
    return null;
  }

  if (!(needLoadInternetOffer && partnerInternetOffer)) {
    return (
      partnerSettings.use_fmb &&
      !!internetOffer && (
        <Grow unmountOnExit in>
          <div>
            <InternetOption isIframe={isIframe} unique_id={unique_id} data={internetOffer} />
          </div>
        </Grow>
      )
    );
  }

  return (
    <Grow unmountOnExit in>
      <div>
        <InternetOption
          data={partnerInternetOffer}
          loading={claimPartnerInternetOfferLoading}
          onClaim={() => claimPartnerInternetOffer(partnerInternetOffer.id)}
        />
      </div>
    </Grow>
  );
}

PartnerInternetOffer.defaultProps = {
  partnerBundleSlugs: [],
};

PartnerInternetOffer.propTypes = {
  partnerBundleSlugs: PropTypes.array,
};

export default React.memo(PartnerInternetOffer);
